export default "__VITE_ASSET__BgpEQ6qw__"